export class Provider {
  provider_id: number;
  name: string;
  from_email: string;
  encryption: string;
  gateway_flag: number;
  // service_flag: number;
  node_id: number;
  host: number;
  port: number;
  username: string;
  password: string;
  dialstring: string;
  prefix: number;
  settings: string;
  register: boolean;
  weight: number;
  type: any;
  active: any;
  httpkey: any;
}
